import React from 'react'
import { Form, Input, Select, Message, Modal } from 'antd'
import { addPrinter } from '../../../api/printer'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.qrCodeRef = React.createRef()
    this.nameRef = React.createRef()
  }

  state = {
    qrCode: '',
    name: '',
  }

  componentDidMount() {
    this.qrCodeRef.current.focus()
  }

  // 新增打印机
  newPrinter = async () => {
    const { qrCode, name } = this.state
    if (!qrCode || !name) {
      Message.error('请完整填写信息')
      return
    }
    const clubId = sessionStorage.getItem('club_id')
    const { data, status, detail } = await addPrinter({
      qrCode,
      name,
      clubId,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    this.setState(
      {
        qrCode: '',
        name: '',
      },
      // () => {
      //   this.qrCodeRef.current.focus()
      // }
      () => {
        this.props.onNewCancel()
        this.props.getPrinterList(this.props.choosePrinter)
      }
    )
  }

  render() {
    const { qrCode, name } = this.state

    return (
      <Modal
        title="新增小票机"
        visible={this.props.newVisible}
        onCancel={this.props.onNewCancel}
        onOk={this.newPrinter}
        width="30%"
      >
        <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 18,
          }}
        >
          <Form.Item label="系统码">
            <Input
              value={qrCode}
              onChange={(e) => {
                this.setState({
                  qrCode: e.target.value,
                })
              }}
              // onPressEnter={(e) => {
              //   this.nameRef.current.focus()
              // }}
              ref={this.qrCodeRef}
            />
          </Form.Item>

          <Form.Item label="小票机名称">
            <Input
              value={name}
              onChange={(e) => {
                this.setState({
                  name: e.target.value,
                })
              }}
              // onPressEnter={(e) => {
              //   this.newPrinter()
              // }}
              ref={this.nameRef}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubPrinterManage/components/newModal.js